import { NotificationListFiltersEmailSmsDto } from '@dto/notification-list/notification-list-filters-email-sms.dto';
import { NotificationDto } from '@dto/notification-list/notification.dto';
import { getInitialNotificationPagination, NotificationPagination } from '@entity/notification-pagination.entity';
import { createReducer, on } from '@ngrx/store';
import { NullableType } from '@type/nullable.type';
import {
  changeProductIdFilterEmailSms,
  loadNotificationListEmailSms,
  loadNotificationListEmailSmsFailure,
  loadNotificationListEmailSmsSuccess,
} from './notification-list-email-sms.action';

export const initFiltersEmailSms: NotificationListFiltersEmailSmsDto = {
  sourceId: '',
  eventTypes: [],
  productIds: [],
  receiver: '',
  date: '',
  status: '',
  notificationTypes: ['EMAIL', 'SMS'],
};

export interface NotificationsEmailSms {
  data: NotificationDto[];
  filters: NotificationListFiltersEmailSmsDto;
  isLoading: boolean;
  error: NullableType<string>;
}

export interface NotificationListEmailSmsState {
  notification: NotificationsEmailSms;
  notificationPagination: NotificationPagination;
}

export const initialStateEmailSms: NotificationListEmailSmsState = {
  notification: {
    data: [],
    filters: initFiltersEmailSms,
    isLoading: false,
    error: null,
  },
  notificationPagination: getInitialNotificationPagination(),
};

export const notificationListEmailSmsReducer = createReducer(
  initialStateEmailSms,

  on(loadNotificationListEmailSms, (state, { currentPageNumber, filters, pageSize }) => ({
    ...state,
    notification: {
      ...state.notification,
      filters,
      isLoading: true,
    },
    notificationPagination: {
      ...state.notificationPagination,
      currentPageNumber,
      pageSize,
    },
  })),

  on(loadNotificationListEmailSmsSuccess, (state, { notificationList }) => ({
    ...state,
    notification: {
      ...state.notification,
      data: notificationList.notifications,
      isLoading: false,
      error: null,
    },
    notificationPagination: {
      ...state.notificationPagination,
      totalNotifications: notificationList.totalNotifications,
      totalPages: notificationList.totalPages,
    },
  })),

  on(loadNotificationListEmailSmsFailure, (state, { error }) => ({
    ...state,
    notification: {
      ...state.notification,
      error,
      isLoading: false,
    },
    notificationPagination: getInitialNotificationPagination(),
  })),

  on(changeProductIdFilterEmailSms, (state, { filters }) => ({
    ...state,
    notification: {
      ...state.notification,
      filters,
    },
  }))
);
